import * as React from 'react';

function SvgWalk(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        d="M10.38 5.02l4.24.53 2.1 3.78 2.87 1.8-1.24 1.98-3.39-2.12-1.16-2.1-.84 4.62 2.78 3.12 1.63 6.53-2.28.57-1.49-5.97-2.65-2.98-.64 3.2L7.11 24l-2.07-1.1 3.04-5.71.75-3.74h.02l1.03-4.87L8.6 9.7l-1.46 3.28L5 12.03l1.67-3.75 3.71-3.26zM12.72 0a2.34 2.34 0 110 4.69 2.34 2.34 0 010-4.69z"
      />
    </svg>
  );
}

export default SvgWalk;
